import {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    object,
    moreNav,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
} from './ThirdMapping';

var entitiesTabs = [
    {
        label: Loc.g('Activité'),
        value: 'activity',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Éléments épinglés'),
        value: 'pinned',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Commentaires'),
        value: 'note',
        entities: ['annotation'],
        databot: 'delivery-overview__activity--comment-list',
    },
    {
        label: Loc.g('Emails'),
        value: 'email',
        entities: ['email'],
        databot: 'delivery-overview__activity--email-list',
    },
    {
        label: Loc.g('Tâches'),
        value: 'task',
        entities: ['task'],
        databot: 'delivery-overview__activity--task-list',
    },
    {
        label: Loc.g('Evènements'),
        value: 'event',
        entities: ['event'],
        databot: 'delivery-overview__activity--event-list',
    },
    {
        label: Loc.g('Appels'),
        value: 'phonecall',
        entities: ['phonecall'],
        databot: 'delivery-overview__activity--call-list',
    },
    {
        label: Loc.g('Marketing'),
        value: 'marketing',
        entities: ['marketing'],
        databot: 'delivery-overview__activity--marketing-list',
    },
];

var entitiesGroups = [
    {
        label: Loc.g('Activité'),
        value: 'clientActivity',
        entities: [
            'task',
            'event',
            'annotation',
            'email',
            'phonecall',
            'client',
            'timetracking',
            'ticket',
            'snippettracking',
            'marketing',
        ],
    },
    {
        label: Loc.g('Prospection'),
        value: 'prospection',
        entities: ['campaign', 'opportunity', 'estimate', 'propdocument'],
    },
    {
        type: 'component',
        component: 'timeline-author-filter',
        label: Loc.g('Collaborateurs'),
        value: 'authors',
        filter: true,
        entities: [],
        display: 'block',
    },
];

var defaultEntities = [
    'email',
    'phonecall',
    'client',
    'annotation',
    'event',
    'task',
    'timetracking',
    'ticket',
    'campaign',
    'opportunity',
    'estimate',
    'propdocument',
    'snippettracking',
    'marketing',
];

var forcedLabel = [
    {
        value: 'document',
        label: Loc.g('Mises à jour'),
    },
];

var availableStatCards = [
    'invoice_third',
    'estimate_third',
    'turnover_third',
    'top_selling_items_third',
    'sales_margin_third',
];

const databots = {
    activity: 'delivery-overview__menu--activity',
    informations: 'delivery-overview__menu--general-info',
    financialactivity: 'delivery-overview__menu--financial-info',
    contacts: 'delivery-overview__menu--contact-linked',
    addresses: 'delivery-overview__menu--address',
    customfields: 'delivery-overview__menu--cf',
    statistics: 'delivery-overview__menu--stat',
    opportunity: 'delivery-overview__menu--opportunity',
    estimate: 'delivery-overview__menu--document',
    invoice: 'delivery-overview__menu--document',
    delivery: 'delivery-overview__menu--document',
    order: 'delivery-overview__menu--document',
    creditnote: 'delivery-overview__menu--document',
    proforma: 'delivery-overview__menu--document',
    payments: 'delivery-overview__menu--payment',
    bankaccount: 'delivery-overview__menu--bank-account',
    recurring: 'delivery-overview__menu--recurring',
    mandates: 'delivery-overview__menu--mandate',
    timetracking: 'delivery-overview__menu--timetracking',
    tickets: 'delivery-overview__menu--ticket',
    project: 'delivery-overview__menu--project',
    proposal: 'delivery-overview__menu--proposal',
    emailingprofile: 'delivery-overview__menu--mailing-list',
    massmailingMailinglist: 'delivery-overview__menu--mailing-list',
    massmailingCampaignList: 'delivery-overview__menu--mailing-list',
    receipts: 'delivery-overview__menu--receipt',
    briefcase: 'delivery-overview__menu--briefcase',
    activitycommentadd: 'delivery-overview__activity--comment-add',
    emailadd: 'delivery-overview__activity--email-add',
    calladd: 'delivery-overview__activity--call-add',
    taskadd: 'delivery-overview__activity--task-add',
    eventadd: 'delivery-overview__activity--event-add',
    generalinfoedit1: 'delivery-overview__section--general-info-edit-1',
    generalinfoedit2: 'delivery-overview__section--general-info-edit-2',
    marketing: 'delivery-overview__section--marketing',
};

export {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    entitiesTabs,
    defaultEntities,
    entitiesGroups,
    forcedLabel,
    object,
    moreNav,
    availableStatCards,
    databots,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
};
